import financial_detail_overviews from "../constants/financial_detail_overviews";
import financial_insights_overviews from "../constants/financial_insights_overviews";
import { default_bubblechart_data } from "../constants/charts";

export const getFinancialDetailOverviewData = (calls, sales) => {
  // let financial_overviews = {
  //   all: {
  //     ...financial_detail_overviews.all,
  //     count: Object.values(calls).length === 0 ? 0 : calls.total_calls,
  //   },
  // };
  let financial_overviews = financial_detail_overviews;
  if (Object.values(sales).length === 0) return financial_overviews;

  // TODO change to all_calls after modifing API return value
  financial_overviews = {
    ...financial_overviews,
    total_calls: {
      ...financial_detail_overviews.total_calls,
      count: sales.total_calls,
    },
    average_revenue: {
      ...financial_detail_overviews.average_revenue,
      count: sales.average_revenue,
      currency_sign: "€",
    },
    // outgoing_calls_count: {
    //   ...financial_detail_overviews.outgoing_calls_count,
    //   count: sales.outgoing_calls_count,
    // },
    total_revenue: {
      ...financial_detail_overviews.total_revenue,
      count: sales.total_revenue,
      currency_sign: "€",
    },
  };
  return financial_overviews;
};

export const getFinancialInsightsCallsOverviewData = (calls, sales) => {
  let financial_overviews = {};
  if (Object.values(sales).length === 0) return financial_insights_overviews;

  // TODO change to all_calls after modifing API return value
  financial_overviews = {
    ...financial_overviews,
    total_calls: {
      ...financial_insights_overviews.total_calls,
      count: sales.total_calls,
    },
    // outgoing_calls_count: {
    //   ...financial_insights_overviews.outgoing_calls_count,
    //   count: sales.outgoing_calls_count,
    // },
    average_basket: {
      ...financial_insights_overviews.average_basket,
      count: sales.average_basket,
      currency_sign: "€",
    },
    company_average_basket: {
      ...financial_insights_overviews.company_average_basket,
      count: sales.company_average_basket,
      currency_sign: "€",
    },
    average_revenue: {
      ...financial_insights_overviews.average_revenue,
      count: sales.average_revenue,
      currency_sign: "€",
    },
    total_revenue: {
      ...financial_insights_overviews.total_revenue,
      count: sales.total_revenue,
      currency_sign: "€",
    },
  };
  return financial_overviews;
};

export const getTopFlopSales = (sales) => {
  const filtered_sales = sales.filter((sale) => sale?.revenue > 0);
  const sorted_sales = filtered_sales.sort((a, b) => Number(b.revenue) - Number(a.revenue));
  const top_sales = sorted_sales.slice(0, 2);
  const flop_sales = sorted_sales.slice(sorted_sales.length - 2);
  if (sorted_sales?.length <= 4) {
    return sorted_sales;
  }
  return [...top_sales, ...flop_sales];
};

export const searchFinancialSales = (sales, search_text) => {
  if (sales.length === 0) return sales;
  let filtered_sales = sales;

  if (search_text !== "") {
    filtered_sales = filtered_sales.filter((sale) => {
      // Check each specified field against the provided criteria
      const matches_operator_name = sale?.name?.toLowerCase()?.includes(search_text.toLowerCase());
      const matches_team = sale?.team?.toLowerCase()?.includes(search_text.toLowerCase());
      const matches_calls = sale?.outgoing_call_count
        ?.toString()
        ?.toLowerCase()
        ?.includes(search_text.toLowerCase());
      const matches_sales = sale?.revenue
        ?.toString()
        ?.toLowerCase()
        ?.includes(search_text.toLowerCase());
      const matches_department = sale?.department
        ?.toLowerCase()
        .includes(search_text.toLowerCase());

      // Return true if any specified fields match the criteria
      return (
        matches_operator_name ||
        matches_team ||
        matches_department ||
        matches_calls ||
        matches_sales
      );
    });
  }
  return filtered_sales;
};

export const getBubbleChartData = (data) => {
  // const chart_data = data.map((item, i) => ({
  //   x: item.outgoing_calls_count + i,
  //   y: item.average_basket + i * 5,
  //   infos: item,
  // }));

  const chart_data = [];

  data.forEach((item, i) => {
    // Anonymized entries
    if (Array.isArray(item)) {
      item.forEach((subItem) => {
        chart_data.push({
          x: subItem.average_basket,
          y: subItem.outgoing_calls_count,
          infos: {
            ...subItem,
            name: "Anonymized",
          },
        });
      });
    } else {
      chart_data.push({
        x: item.average_basket,
        y: item.outgoing_calls_count,
        infos: item,
      });
    }
  });

  return {
    ...default_bubblechart_data,
    datasets: [
      {
        ...default_bubblechart_data.datasets[0],
        data: chart_data,
      },
    ],
    backgroundColor: (context) => {
      const { value, x, y } = context.dataset.data[context.dataIndex];
      // TODO change to mean
      if (x < 600 && y < 15) {
        return "rgba(255, 0, 0, 1)"; // Red color
      }
      if (x >= 660 && y >= 25) {
        return "rgba(0, 255, 0, 1)"; // Green color
      }
      return "rgba(255, 255, 0, 1)"; // Yellow color
    },

    hoverBackgroundColor: (context) => {
      const { value, x, y } = context.dataset.data[context.dataIndex];
      if (x < 10) {
        return "rgba(255, 0, 0, 0.6)"; // Red color
      }
      if (x >= 10 && x <= 50) {
        return "rgba(255, 255, 0, 0.6)"; // Yellow color
      }
      return "rgba(0, 255, 0, 0.6)"; // Green color
    },
  };
};
